<div class="download-header">
  <p>
    {{ "downloads.my-downloads" | translate }}
  </p>
  <!--    <button mat-raised-button  class="frmg-primary-button"-->
  <!--            (click)="getTasks()">-->
  <!--        <span class="material-symbols-outlined action-icon">sync</span>Sync Now</button>-->
</div>

<div class="download-table">
    <div class="table-header">
        All requests
    </div>
    <div class="table-container">
        <table mat-table [dataSource]="taskData" class="mat-elevation-z8" matSort>
            <ng-container matColumnDef="area">
                <mat-header-cell *matHeaderCellDef > Request Name </mat-header-cell>
                <mat-cell *matCellDef="let element"
                          [matTooltipDisabled]="element.area ? element.area.name.length<50 : element.name.length<50"
          [matTooltip]="element.area ? element.area.name: element.name">
        {{element.name | truncate: 50}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="total_aois">
        <mat-header-cell *matHeaderCellDef > Total AIOs </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.total_tasks}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="layer">
        <mat-header-cell *matHeaderCellDef > {{"downloads.table.layer" | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.layer && element.layer.display_name}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef > {{"downloads.table.created_at" | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.created_at | date: "dd/M/yyyy, HH:mm"}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef > {{"downloads.table.status" | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element" >
          <div class="status-block">
            <span [ngClass]="statusClass(element)"></span>
            <span>{{element.status === 'pending'? (element.completed_tasks+"/"+element.total_tasks) : ''}} {{taskStatusTranslations.get(element.status) | translate}}</span>
          </div>

        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef ></mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.status === 'completed') {
            <button mat-raised-button class="frmg-primary-button"
              (click)="download(element, $event)">
              <span class="material-symbols-outlined action-icon">download</span> Download</button>
            }
            <button mat-raised-button class="frmg-secondary-button"
              (click)="deleteDownload(element, $event)">
              <!--                        <span class="icon icon-remove"></span>-->
              <inline-svg src="remove.svg" class="remove-icon"></inline-svg>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goToTask(row)"></mat-row>
      </table>
    </div>
    <mat-divider ></mat-divider>
    <mat-paginator
      [length]="totalElements"
      [pageIndex]="currentPage-1"
      [pageSize]="pageSize"
      [pageSizeOptions]="[50, 100, 15]"
      [showFirstLastButtons]="true"
      (page)="handlePageEvent($event)"
    ></mat-paginator>

  </div>
